import React from "react";
import { Link } from "react-router-dom";

import "./SpecialButton.scss";
import { ReactSVG } from "react-svg";

const SpecialButton = ({
  className,
  link,
  children,
  onClick,
  buttonAsLink,
}) => {
  return (
    <div className={`special-button ${className}`}>
      {buttonAsLink ? (
        <>
          <Link className="link-mobile" to={link}>
            <button className="theme-button link-button" onClick={onClick}>
              {children}
            </button>
            <Link className="image-wrap" to={link}>
              <ReactSVG
                className="arrow-in-button"
                src="/icons/tools/arrow-next.svg"
              />
            </Link>
          </Link>
        </>
      ) : (
        <>
          {link ? (
            <>
              {" "}
              <button className="theme-button" onClick={onClick}>
                {children}
              </button>
              <Link className="image-wrap" to={link ? link : "./"}>
                <ReactSVG
                  className="arrow-in-button"
                  src="/icons/tools/arrow-next.svg"
                />
              </Link>
            </>
          ) : (
            <div onClick={onClick}>
              <button className="theme-button">{children}</button>
              <Link className="image-wrap" to={link ? link : "./"}>
                <ReactSVG
                  className="arrow-in-button"
                  src="/icons/tools/arrow-next.svg"
                />
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SpecialButton;
